export default __webpack_public_path__ + "static/media/bootorg.35fec8a2.png";